//mui
import {Box, FormControl, RadioGroup, Typography} from '@mui/material';
//constants
import {PAID_BY_CASH_ORE_CHECK, PAY_WITH_CREDIT_CARD, PRIMARY, SUBTITLE1} from '@/utils/constants';
//components
import Radio from '@/shared/components/Radio';
//enums
import {PAYMENT_METHOD} from '@/utils/enums';
//icons
import {ReactComponent as CardIcon} from '@/assets/icons/card.svg';
import {ReactComponent as WalletIcon} from '@/assets/icons/wallet.svg';
//styles
import {paymentOptionsStyles} from './PaymentOptions.styles';

const PaymentOptions = ({
	paymentOption,
	setPaymentOption,
}: {
	paymentOption: string;
	setPaymentOption: (value: string) => void;
}) => {
	return (
		<Box>
			<FormControl>
				<RadioGroup defaultValue={PAYMENT_METHOD.CREDIT_CARD}>
					<Box sx={paymentOptionsStyles.content}>
						<Box
							sx={{
								...paymentOptionsStyles.radio,
								...(paymentOption === PAYMENT_METHOD.CREDIT_CARD && paymentOptionsStyles.activeRadio),
							}}
						>
							<Radio
								color={PRIMARY}
								label={
									<Box sx={paymentOptionsStyles.radioLabel}>
										<CardIcon />
										<Typography variant={SUBTITLE1} sx={paymentOptionsStyles.radioTitle}>
											{PAY_WITH_CREDIT_CARD}
										</Typography>
									</Box>
								}
								checked={paymentOption === PAYMENT_METHOD.CREDIT_CARD}
								onChange={() => setPaymentOption(PAYMENT_METHOD.CREDIT_CARD)}
							/>
						</Box>

						<Box
							sx={{
								...paymentOptionsStyles.radio,
								...(paymentOption === PAYMENT_METHOD.CASH_OR_CHECK && paymentOptionsStyles.activeRadio),
							}}
						>
							<Radio
								color={PRIMARY}
								label={
									<Box sx={paymentOptionsStyles.radioLabel}>
										<WalletIcon />
										<Typography variant={SUBTITLE1} sx={paymentOptionsStyles.radioTitle}>
											{PAID_BY_CASH_ORE_CHECK}
										</Typography>
									</Box>
								}
								checked={paymentOption === PAYMENT_METHOD.CASH_OR_CHECK}
								onChange={() => setPaymentOption(PAYMENT_METHOD.CASH_OR_CHECK)}
							/>
						</Box>
					</Box>
				</RadioGroup>
			</FormControl>
		</Box>
	);
};

export default PaymentOptions;
